import CONQUER from "../CONQUER";
import { Platform } from "../UTILS/Types";

type Callback = Promise<{result:boolean, error?:Error}>

class MiscSystem
{
    private conquer : CONQUER;

    constructor( conquer:CONQUER )
    {
        this.conquer = conquer;

        if (typeof window == 'undefined') return;
        
        if (typeof (window as any).onMessageToWebviewReceived != 'undefined') {
            (window as any).onMessageToWebviewReceived.push((endpoint:any, message:any) => { 
                (window as any).conquer.MiscSystem.onMessageToWebviewReceived(endpoint, message);
            });
        }
    }

    private onMessageToWebviewReceived(endpoint:string, message:string) {
        var result = JSON.parse(message);
        if (endpoint == `purchase`) {
            // do something
        }
    }

    public async setNotification(notifId:string, notifTitle:string, notifDelay:number) {
        if (this.conquer.currentPlatform == 'Android' || this.conquer.currentPlatform == 'iOS') 
        {
            if (typeof (window as any).setNotification == 'undefined') {
                return Promise.resolve({
                    result:false, 
                    error:new Error(`[notification] ${this.conquer.currentPlatform} is not implemented`)
                });
            }
            (window as any).setNotification(notifId, notifTitle, notifDelay);
            return Promise.resolve({ result: true });
        }
        return Promise.resolve({
            result:false, 
            error:new Error(`[notification] ${this.conquer.currentPlatform} is not recognized`)
        });
    }

    public async rateApp() {
        if (this.conquer.currentPlatform == 'Android' || this.conquer.currentPlatform == 'iOS') 
        {
            if (typeof (window as any).rateApp == 'undefined') {
                return Promise.resolve({
                    result:false, 
                    error:new Error(`[rate] ${this.conquer.currentPlatform} is not implemented`)
                });
            }
            (window as any).rateApp();
            return Promise.resolve({ result: true });
        }
        return Promise.resolve({
            result:false, 
            error:new Error(`[rate] ${this.conquer.currentPlatform} is not recognized`)
        });
    }

    public async showGDPR() {
        if (this.conquer.currentPlatform == 'Android' || this.conquer.currentPlatform == 'iOS') 
        {
            if (typeof (window as any).showGDPR == 'undefined') {
                return Promise.resolve({
                    result:false, 
                    error:new Error(`[gdpr] ${this.conquer.currentPlatform} is not implemented`)
                });
            }
            (window as any).showGDPR();
            return Promise.resolve({ result: true });
        }
        return Promise.resolve({
            result:false, 
            error:new Error(`[gdpr] ${this.conquer.currentPlatform} is not recognized`)
        });
    }

    public async purchase(productId:string)
    {
        if (this.conquer.currentPlatform == 'Android' || this.conquer.currentPlatform == 'iOS') 
        {
            if (typeof (window as any).purchase == 'undefined') {
                return Promise.resolve({
                    result:false, 
                    error:new Error(`[purchase] ${this.conquer.currentPlatform} is not implemented`)
                });
            }
            let output = await (window as any).purchase(productId);
            return Promise.resolve({ result: output.result, error: output.error});
        }
        return Promise.resolve({
            result:false, 
            error:new Error(`[purchase] ${this.conquer.currentPlatform} is not recognized`)
        });
    }

}

export default MiscSystem;